<template>
	<el-container style="height: 100%;">
		<template v-if="device!=='pc'">
			<div class="full flex" style="flex-direction: column;justify-content:center;" ref="main">
				<div style="flex: 1;overflow-y: auto;overflow-x: hidden;position: relative;">
					<keep-alive>
						<router-view></router-view>
					</keep-alive>
				</div>
				<van-tabbar v-model="activeName" style="width: 100%;position: relative;">
					<van-tabbar-item v-if="cooperate" name="matter" icon="records" to="/main/cooperate/matter/index">工作台
					</van-tabbar-item>
					<!-- 					<van-tabbar-item v-if="datacenter" name="datacenter" icon="records" to="/main/datacenter/index">数据概览
					</van-tabbar-item> -->
					<!-- 					<van-tabbar-item name="message" icon="records" to="/main/cooperate/message/index">我的消息
					</van-tabbar-item> -->
					<van-tabbar-item name="flowtemplate" icon="orders-o" to="/main/cooperate/flowtemplate/index">流程模板
					</van-tabbar-item>
					<van-tabbar-item name="module" icon="apps-o" to="/components/phoneNav">模块</van-tabbar-item>
					<van-tabbar-item name="report" icon="chart-trending-o"
						to="/main/cooperate/report/index">报表</van-tabbar-item>
					<van-tabbar-item name="scan" icon="scan" to="/main/cooperate/scan/index">扫码</van-tabbar-item>
				</van-tabbar>
			</div>
		</template>
		<template v-else>
			<el-aside class="flex" width="auto"
				style="background-color: #303133;flex-direction: column;overflow: hidden;">
				<div class="nav_header flex">
					<Avatar :username="user.name" src="" background-color="#409eff" color="#fff" style="margin: 0 10px;"
						:inline="true">
					</Avatar>
					<div class="nav_header_info">
						<div>{{user.name}}</div>
						<div style="font-size: 12px;margin-top: 4px;">{{user.department}}</div>
						<el-tag effect="dark" size="mini" :type="online?'success':'info'" class="tag">
							{{online?'在线':'离线'}}
						</el-tag>
						<!-- 						<el-link type="success" style="font-size: 12px;" @click="onlineShow = true">在线人数:{{onlinelist}}
						</el-link> -->
						<el-link type="success" style="font-size: 12px;" @click="onlineShow = true">查看在线人员
						</el-link>
					</div>
				</div>

				<div style="flex: 1;overflow: auto;box-sizing: border-box;">
					<el-menu :router="true" :default-active="defaultActive" class="el-menu-vertical-demo"
						@open="handleOpen" @close="handleClose" :collapse="isCollapse" background-color="#303133"
						text-color="#fff" active-text-color="#ffd04b">
						<sideNav @manual="manualHandle" v-for="(item , index) in nav" :key="index" :item="item" />
					</el-menu>
				</div>
			</el-aside>
			<el-container>
				<el-header height="40px" class="main_header flex" style="padding: 0;">
					<!-- 								<div class="collapse_button flex" @click="collapseHandle" style="color: #303133;">
						<i v-show="!isCollapse" class="el-icon-s-fold"></i>
						<i v-show="isCollapse" class="el-icon-s-unfold"></i>
					</div> -->
					<el-breadcrumb style="margin-left: 20px;">
						<el-breadcrumb-item v-for="(item,index) in breadcrumb" :key="index">{{item}}
						</el-breadcrumb-item>
					</el-breadcrumb>
					<div class="header_right_container">
						<div class="header_right_button flex">
							<el-dropdown @command="mainCommand">
								<i class="el-icon-s-home" style="font-size: 22px;"></i>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="changekey">修改密码</el-dropdown-item>
									<el-dropdown-item command="company">切换主体</el-dropdown-item>
									<el-dropdown-item command="logout">退出</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
						<!-- 					<div class="userinfo flex">
							<el-tag size="mini">协同中心</el-tag>
						</div> -->
						<div class="header_right_button flex">
							<el-dropdown @command="mainCommand" @visible-change="mainDropdownChange">
								<span class="el-dropdown-link">
									工具<i class="el-icon-arrow-down el-icon--right"></i>
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item :command="item.code" v-for="(item,index) in systemtool"
										:key="index">{{item.name}}</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
						<div class="header_right_button flex" style="margin-right: 20px;" v-if="equipment">
							<el-dropdown @command="equipmentCommand">
								<span class="el-dropdown-link">
									设备<i class="el-icon-arrow-down el-icon--right"></i>
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item :command="item.code" v-for="(item,index) in equipment"
										:key="index">{{item.name}}</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
						<!-- 						<div class="header_right_button flex" style="margin-right: 10px;">							
							<el-button type="text" style="color: #606266;">摄像头</el-button>
						</div> -->
					</div>
				</el-header>
				<div class="tabs_container flex">
					<headerTab v-for="(item,index) in tabs" :key="index" :cancle="index!=0" :item="item" />
				</div>
				<el-main ref="main" style="position: relative;padding: 0;overflow: hidden;">
					<keep-alive>
						<router-view :key="$route.meta.timeStamp"></router-view>
					</keep-alive>
					<!-- 				<transition name="right">
						<keep-alive>
							<router-view :key="$route.meta.timeStamp"></router-view>
						</keep-alive>
					</transition> -->
				</el-main>
			</el-container>
			<editPassword :visible="editPasswordShow" @close="editPasswordShow=false" />

			<tool :name="toolname" v-if="toolname!=''" @back="toolname=''" />

			<vxe-modal v-model="onlineShow" width="800" height="750" :title="'人员状态'" destroy-on-close show-footer>
				<online />
			</vxe-modal>

			<vxe-modal v-model="companyShow" width="400" height="auto" :title="'选择主体'" destroy-on-close>
				<div>
					<el-button v-for="(item,index) in appconfig.logincompany" :key="index" plain
						style="width: 100%;margin: 0;margin-bottom: 10px;"
						@click="changecompany(item)">{{item.title}}</el-button>
				</div>
			</vxe-modal>


			<el-drawer :title="manualdata?manualdata.name + '【操作手册】' : '【操作手册】'" :with-header="false"
				:visible.sync="manualShow" direction="rtl" size="80%" destroy-on-close
				:before-close="beforeManualClose">
				<manual ref="manual" :data="manualdata" />
			</el-drawer>


		</template>


	</el-container>
</template>

<style scoped>
	.nav_header {
		position: relative;
		width: 100%;
		height: 100px;
		box-sizing: border-box;
		padding: 10px;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		border-bottom: 1px solid #606266;
	}

	.nav_header_info {
		flex: 1;
		color: white;
		font-size: 14px;
	}

	.main_header {
		flex-direction: row;
		align-items: center;
	}

	.header_right_container {
		height: 60px;
		flex: 1;
		margin-right: 20px;

	}

	.userinfo {
		position: relative;
		font-size: 14px;
		float: right;
		height: 100%;
		flex-direction: column;
		align-items: center;
		justify-content: center;

	}

	.header_right_button {
		width: 50px;
		height: 60px;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		float: right;
		font-size: 22px;
	}


	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 200px;
	}

	.el-menu {
		border: 0 !important;
	}

	.collapse_button {
		width: 60px;
		height: 60px;
		font-size: 24px;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		margin-right: 10px;
	}

	.tabs_container {
		position: relative;
		flex-direction: row;
		align-items: center;
		width: 100%;
		height: 40px;
		box-shadow: 0 1px 2px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		padding: 0 10px;
		box-sizing: border-box;
		z-index: 999;

	}

	.tag {
		-webkit-transform: scale(0.8);
		-webkit-transform-origin: 0 100%;
	}

	.right-enter,
	.right-leave-to {
		transform: translate3d(100px, 0, 0);
		opacity: 0;
	}

	.right-leave,
	.right-enter-to {
		transform: translate3d(0, 0, 0);
		opacity: 1;
	}

	.right-enter-active,
	.right-leave-active {
		transition: all .5s
	}
</style>
<script>
	import {
		Loading
	} from 'element-ui';
	import headerTab from '@_system/components/headerTab.vue'
	import sideNav from '@_system/components/sideNav.vue'
	import editPassword from '@_system/components/editPassword.vue'
	import tool from '@/tool/index.vue'
	import online from '@_system/views/main/online/index.vue'
	import manual from '@_system/views/main/manual/index.vue'
	// import matter from '@_system/views/main/cooperate/matter/index.vue'
	// import flowtemplate from '@_system/views/main/cooperate/flowtemplate/index.vue'

	export default {
		data() {
			return {
				appconfig: window.config,
				manualShow: false,
				manualdata: null,
				editPasswordShow: false,
				isCollapse: false,
				activeName: 'matter',
				toolname: '',
				onlineShow: false,
				device: window.systemMethods.device(),
				nav: [],
				datacenter: false,
				cooperate: false,
				equipment: null,
				systemtool: [],
				companyShow: false,

			};
		},
		created() {
			if (this.device != 'pc') {
				this.activeName = this.$router.currentRoute.meta.activeName
			}
			this.datacenter = window.config.systemmodule.find((item) => {
				return item == 'datacenter'
			})
			this.cooperate = window.config.systemmodule.find((item) => {
				return item == 'cooperate'
			})
			this.equipment = window.config.equipment
			this.createNav()
		},
		mounted() {
			//window.console.log($route)
			this.$store.commit('system/setMainContainer', {
				value: this.$refs.main.$el
			})
		},
		watch: {
			currentActive(newValue, oldValue) {
				if (newValue != oldValue) {

					this.linkTo()
				}
			},
		},
		computed: {
			// onlinelist() {
			// 	let onlinelist = this.$store.state.system.onlinelist
			// 	let list = []
			// 	if (JSON.stringify(onlinelist) != "{}") {
			// 		for (let i in onlinelist) {
			// 			list.push(onlinelist[i])
			// 		}
			// 	}
			// 	return list.length
			// },
			online() {
				return this.$store.state.system.online
			},
			user() {
				return this.$store.state.system.user
			},
			breadcrumb() {
				let group = this.$router.currentRoute.meta.group
				if (group) {
					return [group, this.$router.currentRoute.name]
				} else {
					return [this.$router.currentRoute.name]
				}

			},
			tabs() {
				return this.$store.state.main.tabs
			},
			defaultActive() {
				return this.$router.currentRoute.path
			},
			currentTab() {
				return this.$store.state.main.currentTab
			},
			random() {
				return Math.random()
			}
		},
		methods: {
			manualHandle(e) {
				this.manualdata = e.data
				this.manualShow = true
			},
			beforeManualClose(done) {
				if (!this.$refs.manual.editShow) {
					done()
				} else {
					this.$message.error('请先退出编辑状态')
				}
			},
			createNav() {
				let nav = []
				let obj = Object.create(null)
				let routes = this.getNav()
				for (let i = 0; i < routes.length; i++) {
					if (routes[i].meta.group) {
						let group = routes[i].meta.group
						if (!obj[group]) {
							obj[group] = {
								no: routes[i].order,
								controller: routes[i].controller,
								type: routes[i].type,
								items: []
							}
						}
						obj[group].items.push({
							name: routes[i].name,
							id: routes[i].id,
							path: routes[i].path,
							meta: routes[i].meta,
							controller: routes[i].controller,
							type: routes[i].type
						})
					} else {
						if (!obj['nogroup']) {
							obj['nogroup'] = {
								no: routes[i].order,
								items: []
							}
						}
						obj['nogroup'].items.push({
							name: routes[i].name,
							id: routes[i].id,
							path: routes[i].path,
							no: routes[i].order,
							meta: routes[i].meta,
							controller: routes[i].controller,
							type: routes[i].type
						})
					}

				}
				//console.log(obj,44455)
				for (let i in obj) {
					if (i !== 'nogroup') {
						nav.push({
							name: i,
							no: obj[i].order,
							path: i,
							type: obj[i].type,
							controller: obj[i].controller,
							children: obj[i].items
						})
					} else {
						nav = nav.concat(obj[i].items)
					}
				}

				nav.sort(function(a, b) {
					return a.no - b.no;
				})
				//console.log(nav,123123)
				this.nav = nav
				this.$store.commit('system/setNav', nav)
			},
			handleOpen(key, keyPath) {
				window.console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				window.console.log(key, keyPath);
			},
			handleClick(tab, event) {
				window.console.log(tab, event);
			},
			collapseHandle() {
				this.isCollapse = !this.isCollapse
			},
			changecompany(e) {
				// console.log(e,window.config)
				if (e.id == window.config.id) {
					this.$message.error('当前主体【' + e.title + '】无需重复切换')
					return
				}
				// return

				this.loadhandle = Loading.service({
					spinner: 'el-icon-loading',
					text: '',
					background: "rgba(255, 255, 255, 0.5)"
				})


				fetch(e.baseURL + '/' + e.app + '/system/changecompany', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'token': window.localStorage.getItem(this.$store.state.token)
						},
						body: JSON.stringify(e)
					})
					.then(response => response.json())
					.then((res) => {
						if (res.code == 200) {
							res = res.data
							window.localStorage.setItem(this.$store.state.token, res.token)
							window.localStorage.setItem(this.$store.state.logincompany, res.logincompany)
							window.location.reload()
						} else {
							this.$message.error(res.msg)
							this.loadhandle.close()
						}
					})
					.catch((e) => {
						this.$message.error(e)
						this.loadhandle.close()
					})
			},
			mainCommand(command) {
				if (command == 'changekey') {
					this.editPasswordShow = true
				} else if (command == 'logout') {
					this.$confirm('确认退出？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.logout()
					})
				} else if (command == 'company') {
					this.companyShow = true
				} else {
					this.toolname = command
				}
				// switch (command) {
				// 	case 'delivery':
				// 		this.toolname = command
				// 		break
				// 	case 'goodsonline':
				// 		this.toolname = command
				// 		break
				// 	case 'changekey':
				// 		this.editPasswordShow = true
				// 		break
				// 	case 'logout':
				// 		this.$confirm('确认退出？', '提示', {
				// 			confirmButtonText: '确定',
				// 			cancelButtonText: '取消',
				// 			type: 'warning'
				// 		}).then(() => {
				// 			this.logout()
				// 		})
				// 		break
				// }

			},
			equipmentCommand(command) {
				if (command == 'carmera') {

					//alert(window.config.domain)
					let carmera = window.open(window.location.origin + '/H5/carmera/#/home', "摄像头",
						this.$store.state.system.windowConfig)
					carmera.onload = () => {
						console.log('carmera open')
					}
					window.carmera = carmera
				}
			},
			mainDropdownChange() {
				this.systemtool = window.systemData.tool
			},
			logout() {
				window.localStorage.removeItem(this.$store.state.token)
				window.localStorage.removeItem(this.$store.state.logincompany)
				//this.$router.push('/login')
				if (window.location.href.indexOf("?") > 0) {
					window.location.href = window.location.href.substring(0, window.location.href.indexOf(
						"?"));
				} else {
					window.location.href = ''
				}
			},
			changekey() {

			},
			getNav() {
				let routes = this.$router.options.routes

				for (let i = 0; i < routes.length; i++) {
					if (routes[i].path === '/main') {
						return routes[i].children
					}
				}
				return []
			},


		},
		components: {
			headerTab,
			sideNav,
			editPassword,
			tool,
			online,
			manual
			// matter,
			// flowtemplate,
		}
	}
</script>